import React from 'react'
import { Edit } from 'react-admin'

import ChatbotQuestionsForm from './form'

const DynamicSplashScreenEdit = (props) => (
  <Edit {...props}>
    <ChatbotQuestionsForm isEdit={true} {...props} />
  </Edit>
)

export default DynamicSplashScreenEdit
